import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, Title, Tooltip, Legend, PointElement } from 'chart.js';

// Register required Chart.js components
ChartJS.register(LineElement, CategoryScale, LinearScale, Title, Tooltip, Legend, PointElement);

const LineChart = ({chardata}) => {
  const data = {
    labels: chardata.map(item=>item.region), // Replace with your labels
    datasets: [
      {
        label: 'Toatl GP Amount',
        data: chardata.map(item=>item.total_gp_amount), // Data for the first line
        borderColor: 'rgba(255, 99, 132, 1)', // Line color
        backgroundColor: 'rgba(255, 99, 132, 0.2)', // Fill color under the line
        pointBackgroundColor: 'rgba(255, 99, 132, 1)', // Color of data points
        pointBorderColor: '#fff',
        tension: 0.4, // Smoothness of the curve
      },
      {
        label: 'Total Target',
        data: chardata.map(item=>item.total_target), // Data for the second line
        borderColor: 'rgba(54, 162, 235, 1)',
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        pointBackgroundColor: 'rgba(54, 162, 235, 1)',
        pointBorderColor: '#fff',
        tension: 0.4,
      },
      {
        label: 'Total Profit',
        data: chardata.map(item=>item.total_profit), // Data for the third line
        borderColor: 'rgba(75, 192, 192, 1)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        pointBackgroundColor: 'rgba(75, 192, 192, 1)',
        pointBorderColor: '#fff',
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Region Wise Data',
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Regions', // Label for x-axis
        },
      },
      y: {
        title: {
          display: true,
          text: 'Values', // Label for y-axis
        },
        beginAtZero: true, // Ensures the y-axis starts at 0
      },
    },
  };

  return <Line data={data} options={options} />;
};

export default LineChart;
